import React from "react";

const doesNothing = () => {};

const notDeleted = ({ deleted }) => deleted !== true;

const DeleteContentItemButton = ({ onClick = doesNothing }) => (
  <a className="waves-effect borderless" onClick={onClick}>
    <i className="material-icons">delete</i>
  </a>
);

const EditContentItemButton = ({ onClick = doesNothing }) => (
  <a className="waves-effect borderless" onClick={onClick}>
    <i className="material-icons">edit</i>
  </a>
);

const ItemActions = ({ id, onDelete, onEdit }) => (
  <>
    <EditContentItemButton onClick={() => onEdit(id)} />
    <DeleteContentItemButton onClick={() => onDelete(id)} />
  </>
);

const findTheValueOption = (value, { options = [] }) =>
  options.find((option) => option.value === value) || {};

const labelOf = (option = { label: "missinig value" }) => option.label;

export const classForType = (type) => (type === "number" ? "text-right" : "");
const actionsClassForFields = (fields) => (fields.length < 2 ? "width-50" : "");

const Value = ({ value = undefined, type, name, item, field }) =>
  type === "select" ? (
    <Value
      type="text"
      value={labelOf(findTheValueOption(item[name], field))}
      item={item}
      name={name}
    />
  ) : (
    <span>{value !== undefined ? value : item[name]}</span>
  );

const ItemRow = ({
  fields = [],
  even = true,
  onDelete = doesNothing,
  onEdit = doesNothing,
  ...item
}) => (
  <tr className={`${even ? "even" : "odd"}`}>
    {fields.map(({ name, type, Component = Value, ...field }) => (
      <td key={name} className={classForType(type)}>
        <Component
          readOnly={true}
          value={item[name]}
          {...{ name, type, item, field }}
        />
      </td>
    ))}
    <td className="actions text-center hides-content-to-operators">
      <ItemActions id={item.__id} onEdit={onEdit} onDelete={onDelete} />
    </td>
  </tr>
);

const ListItems = ({
  className = "",
  items = [],
  fields = [],
  onDelete = doesNothing,
  onEdit = doesNothing,
}) => (
  <table className={`profiles table table-class-striped ${className} `}>
    <thead>
      <tr>
        {fields.map(({ name, label, type, colHeadClass }) => (
          <th key={name} className={colHeadClass || classForType(type)}>
            {label.toUpperCase()}
          </th>
        ))}
        <th className={`text-center ${actionsClassForFields(fields)}`}>
          Actions
        </th>
      </tr>
    </thead>
    <tbody>
      {items.filter(notDeleted).map((item, index) => (
        <ItemRow
          fields={fields}
          key={item.__id}
          index={index}
          {...item}
          even={(index + 1) % 2 === 0}
          onDelete={onDelete}
          onEdit={onEdit}
        />
      ))}
    </tbody>
  </table>
);

export default ListItems;
